<ion-app>
    <ion-menu
            contentId="main-content"
            *ngIf="(currentUser && (currentUser.manager || isHrOrHasReportAccess) && !passwordChangeRequired) || isAdmin()">
        <ion-header no-border mode="md">
            <ion-toolbar mode="md" color="primary">
                <ion-title>Menu</ion-title>
            </ion-toolbar>
        </ion-header>
        <ion-content color="primary" (click)="getNotifications()">
            <ion-list mode="ios" lines="full" lines="none">
                <ion-item-divider>
                    <ion-label>
                        PERFORMANCE
                    </ion-label>
                </ion-item-divider>
                <ion-menu-toggle auto-hide="false">
                    <ion-item (click)="goToDashboard()" style="cursor: pointer;" color="primary">
                        <ion-label>
                            Dashboard
                        </ion-label>
                    </ion-item>
                    <a *ngIf="tutorialMenu" [href]="tutorialPath">
                        <ion-item color="primary">
                            <ion-label class="ion-text-wrap">
                                Tutorial
                            </ion-label>
                        </ion-item>
                    </a>
                </ion-menu-toggle>

                <ion-item-divider>
                    <ion-label class="ion-text-wrap">
                        ADMIN
                    </ion-label>
                </ion-item-divider>

                <ng-container *ngFor="let p of appPages" >
                    <ion-menu-toggle auto-hide="false" *ngIf="p.url; else groupHeader">
                        <ion-item [routerDirection]="'root'" [routerLink]="[p.url]" color="primary">
                            <ion-label class="ion-text-wrap">
                                {{ p.title | translate }}
                            </ion-label>
                        </ion-item>
                    </ion-menu-toggle>
                    
                    <ng-template #groupHeader>
                        <ion-item class="menu-group-header" color="primary" [detail]="false" button="false">
                            <ion-label class="ion-text-wrap">
                                {{ p.title | translate }}
                            </ion-label>
                             <ion-icon slot="end" name="chevron-forward" 
                                style="transform: rotate(90deg); opacity: 0.75; font-size: 18px;"></ion-icon>
                        </ion-item>
                    </ng-template>
                    
                    <ion-menu-toggle auto-hide="false" *ngFor="let s of p.children">
                        <ion-item [routerDirection]="'root'" [routerLink]="[s.url]"
                        style="opacity: 95%;" color="primary">
                        <ion-label class="ion-text-wrap" style="padding-left: 25px;">
                            {{ s.title | translate }}
                        </ion-label>
                    </ion-item>
                </ion-menu-toggle>
            </ng-container>
            </ion-list>
        </ion-content>
    </ion-menu>

    <div id="main-content">
        <ion-header class="hideFromPrinting" mode="md">
            <ion-toolbar mode="md">
                <ion-buttons slot="start" *ngIf="currentUser">
                    <ion-menu-button>
                        <ion-icon class="bp-menu"></ion-icon>
                    </ion-menu-button>
                </ion-buttons>
                <ion-title>
                    <div class="logo">
                        <img (click)="goToDashboard()" [src]="logoUrl" alt="">
                    </div>
                </ion-title>
                <ion-buttons slot="end">
                    <div *ngIf="showNotificationsFeature && currentUser">
                        <ion-button fill="clear" mode="ios" (click)="openJobFollowUpModal()">
                            <ion-icon name="stats-chart-outline"
                                      [ngStyle]="{'color': 'var(--notification-icon-color)'}"></ion-icon>
                            <ion-badge *ngIf="jobsInProgress > 0">{{ jobsInProgress }}</ion-badge>
                        </ion-button>
                    </div>

                    <div *ngIf="showNotificationsFeature && currentUser">
                        <ion-button fill="clear" mode="ios" (click)="openNotificationModal()">
                            <ion-icon name="notifications-outline"
                                      [ngStyle]="{'color': 'var(--notification-icon-color)'}"></ion-icon>
                            <ion-badge *ngIf="notificationsNotRead > 0">{{ notificationsNotRead }}</ion-badge>
                        </ion-button>
                    </div>
                    <div class="profile-details" *ngIf="currentUser">
                        <img [src]="getUserPicture()" alt="" (click)="openProfile()" [ngStyle]="{'cursor': cannotOpenProfile ? 'auto' : 'pointer'}">
                        <div class="profile-title">
                            <h2>{{ getUserName() }}</h2>
                            <p (click)="logOut()" *ngIf="!isImpersonating">
                                {{ 'generic.logout' | translate }}
                            </p>
                        </div>
                    </div>
                    <div class="language-container">
                        <div class="language-desktop">
                            <ion-button fill="clear" mode="ios"
                                        [ngClass]="{ 'active': selectedLanguage === 'pt-BR' }"
                                        (click)="changeLanguage('pt-BR')">
                                PT
                            </ion-button>
                            <ion-button fill="clear" mode="ios"
                                        [ngClass]="{ 'active': selectedLanguage === 'en-US' }"
                                        (click)="changeLanguage('en-US')">
                                EN
                            </ion-button>
                            <ion-button fill="clear" mode="ios"
                                        [ngClass]="{ 'active': selectedLanguage === 'es-ES' }"
                                        (click)="changeLanguage('es-ES')">
                                ES
                            </ion-button>
                        </div>
                    </div>
                </ion-buttons>
            </ion-toolbar>
            <ion-progress-bar type="indeterminate" *ngIf="showLoader"></ion-progress-bar>
        </ion-header>

        <ion-toolbar color="danger" *ngIf="isImpersonating" class="toolbar-impersonating">
            <div class="impersonating-title">
                <span>{{ 'generic.impersonating' | translate }}: </span>
                {{ impersonatedInfo.username }}
            </div>
            <ion-buttons slot="primary">
                <ion-button fill="outline" (click)="leaveImpersonation()">
                    {{ 'generic.leaveImpersonation' | translate }}
                </ion-button>
            </ion-buttons>
        </ion-toolbar>

        <ion-router-outlet id="print-section"
                           [ngClass]="{'impersonating-bottom':isImpersonating}">
        </ion-router-outlet>
    </div>
</ion-app>
